// AuthGuard.jsx
import PropTypes from 'prop-types';
import { useEffect, useCallback, useState, useLayoutEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useRouter } from 'src/routes/hooks';
import { useAuth } from 'src/hooks/useAuth'; // adjust path
import { paths } from 'src/routes/paths';
import { requestNotificationPermission, registerFcmTokenWithBackend } from 'src/utils/firebase';

const loginPaths = {
    jwt: paths.auth.login,
    //   jwt: paths.auth.jwt.login,
    //   auth0: paths.auth.auth0.login,
    //   amplify: paths.auth.amplify.login,
    //   firebase: paths.auth.firebase.login,
};

export default function AuthGuard({ children }) {
    const router = useRouter();
    const { isAuthenticated, authMethod, user } = useAuth(); // from Redux slice now
    const location = useLocation();
    const hasRegisteredFCM = useRef(false);

    useEffect(() => {
        if (!isAuthenticated || !user) {
            hasRegisteredFCM.current = false;
            return;
        }

        // Register FCM token only once per stable login session
        if (!hasRegisteredFCM.current) {
            hasRegisteredFCM.current = true;
            requestNotificationPermission().then((token) => {
                if (token) registerFcmTokenWithBackend(token);
            });
        }

        const requireChange = localStorage.getItem('requirePasswordChange') === 'true' || user.requirePasswordChange;
        if (requireChange && !location.pathname.includes('change-password')) {
            router.push(paths.auth.changePassword);
            return;
        }

        if (user.role === 'admin' && user.hasCompletedOnboarding === false && !location.pathname.includes('/dashboard/onboarding')) {
            router.push(paths.dashboard.onboarding);
        }
    }, [isAuthenticated, user, location.pathname, router]);

    // 🚨 NOT authenticated → declarative redirect
    if (!isAuthenticated) {
        return (
            <Navigate
                to={paths.auth.login}
                replace
                state={{ returnTo: location.pathname }}
            />
        );
    }


    return <>{children}</>;
}

AuthGuard.propTypes = {
    children: PropTypes.node,
};
